// extracted by mini-css-extract-plugin
export default {"toCheckoutContainer":"style_toCheckoutContainer__aDR8w","text":"style_text__xpj66","button":"style_button__cvIaK"};